



















































import { Vue, Component, Model } from 'vue-property-decorator';
import { debounce } from 'typescript-debounce-decorator';
import CompanyDTO from "@/dto/company/CompanyDTO";
import CompanyFilterDTO from "@/dto/company/CompanyFilterDTO";
import CompanyService from "@/services/CompanyService";
import { processError } from "@/utils/ComponentUtils";
import CommonInputMixin from "@/components/new_style_components/mixins/CommonInputMixin.vue";

@Component<SimpleCompanySearch>({
  inheritAttrs: false,
  mixins: [CommonInputMixin],
  watch: {
    selectedCompany(n) {
      if (n === null) {
        this.filter.searchQuery = null;
      }
    }
  }
})
export default class SimpleCompanySearch extends Vue {
  @Model('change', { type: CompanyDTO, default: null })
  private selectedCompany!: CompanyDTO | null;

  private filter = new CompanyFilterDTO({ pageSize: 8 });

  private companies: Array<CompanyDTO> = [];

  private showList = false;

  private dropUp = false;

  mounted(): void {
    if (this.selectedCompany) {
      this.filter.searchQuery = this.selectedCompany.name + ' ' + this.selectedCompany.ein + ' ' + this.selectedCompany.email;
    }
  }

  @debounce(200)
  private search() {
    CompanyService.getByFilter(this.filter).then(
        ok => {
          this.companies = ok.data.data;
          this.showList = true;

          this.$nextTick(() => {
            this.updateDropDownPosition();
          });
        },
        err => processError(err, this)
    )
  }

  selectCompany(c: CompanyDTO): void {
    this.showList = false;
    this.filter.searchQuery = c.name + ' ' + c.ein + ' ' + c.email;
    this.$emit('change', c);
  }

  private updateDropDownPosition() {
    const inputEl = this.$el.querySelector('input');

    const autocompleteEl = this.$refs.autocomplete as HTMLElement;
    if(!inputEl || !autocompleteEl) return;

    const inputRect = inputEl.getBoundingClientRect();

    const windowHeight = window.innerHeight;

    const spaceBelow = windowHeight - inputRect.bottom;

    const dropdownHeight = autocompleteEl.offsetHeight;

    this.dropUp = spaceBelow < dropdownHeight;
  }
}
